import timeutils from 'utils/wt-time-utils'
export default {
  getMenu (data) {
    for (var i = data.length - 1; i >= 0; i--) {
      if (!this.getMenuItem(data[i])) {
        data.splice(i, 1)
      }
      if (data[i] && data[i].children) {
        let children = data[i].children
        for (let a = children.length - 1; a >= 0; a--) {
          if (!this.getMenuItem(children[a])) {
            children.splice(a, 1)
          }
          if (children[a] && children[a].children) {
            let son = children[a].children
            for (let e = son.length - 1; e >= 0; e--) {
              if (!this.getMenuItem(son[e])) {
                son.splice(e, 1)
              }
            }
          }
        }
      }
    }
    // data.forEach(item => {
    //   item = this.getMenuItem(item)
    //   if (item.children) {
    //     item.children.forEach(etem => {
    //       etem = this.getMenuItem(etem)
    //       if (etem.children) {
    //         etem.children.forEach(atem => {
    //           atem = this.getMenuItem(atem)
    //         })
    //       }
    //     })
    //   }
    // })
    return data
  },
  getMenuItem (item) {
    item.leftIcon = item.icon ? ('iconfont ' + item.icon) : null
    delete (item.icon)
    if (item.external) {
      item.action = '/external?url=' + item.url
      item.action = item.action + (item.externalType ? ('&externalType=' + item.externalType) : '')
      item.text = item.displayName
    } else {
      item.action = item.url || ''
      item.text = item.displayName
    }
    if (item.visible === false) {
      return false
    }
    return true
  },
  // CPS合同地址和合同号数据处理
  cpsContractData (data) {
    data.CPSNumber = null
    data.cpsRegion = null
    data.cpsRegion = null
    data.productCode = null
    data.product_code = null
    data.product_name = null
    data.bar_code = null
    data.contract_date = null
    if (data.contractInformation && data.contractInformation.length) {
      data.contractInformation.forEach(etem => {
        data.CPSNumber = data.CPSNumber ? (data.CPSNumber + '/' + etem.contractCode)
          : etem.contractCode
        data.cpsRegion = data.cpsRegion ? (data.cpsRegion + '/' + etem.cpsRegion)
          : etem.cpsRegion
        etem.productInformation = etem.productInformation || []
        etem.contract_date = etem.contractDate && timeutils.format(etem.contractDate, 'date')
        data.contract_date = data.contract_date ? (data.contract_date + '/' + timeutils.format(etem.contractDate, 'date')) : timeutils.format(etem.contractDate, 'date')
        etem.productInformation.forEach(atem => {
          let proName = atem.name ? (atem.name + '-' + atem.productCode) : atem.productCode
          data.productCode = data.productCode ? (data.productCode + '/' + proName) : proName
          data.product_code = data.product_code ? (data.product_code + '/' + atem.productCode) : atem.productCode
          data.product_name = data.product_name ? (data.product_name + '/' + atem.name) : atem.name
          data.product_name = data.product_name ? data.product_name : '--'
          data.bar_code = data.bar_code ? (data.bar_code + '/' + atem.barcode) : atem.barcode
        })
      })
    }
    data.cpsRegion = data.cpsRegion || '--'
    data.CPSNumber = data.CPSNumber || '--'
    return data
  }
}
